import { render } from "./Page.vue?vue&type=template&id=307474b0"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=307474b0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script